import { Card, Stack, Typography } from '@mui/material'
import DoctorIcon from '@/components/ui/icons/Doctor'
import PdsIcon from "@/components/ui/icons/Pds";
import { Staff } from '@/core/models/staff.model'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@/hooks/useSizeBreakpoints';


type InitiatorInfosProps = {
  staff: Staff
  who: 'initiator' | 'required'
}

export default function InitiatorInfos(props: InitiatorInfosProps) {
  const { staff, who } = props

  const { t } = useTranslation()
  const isTooSmall = useIsMobile()

  return (
    <Card sx={{ p: 3 }}>
      <Typography variant="h3" component="div" noWrap sx={{ color: '#6B7280', fontSize: '12px', fontWeight: 700 }}>
        {t(`page.expertiseValidation.infos.${who}.label`)}
      </Typography>
      <Stack direction={isTooSmall ? "column" : "row"} alignItems="center" justifyContent="space-between" spacing={3}>
        <Stack direction="column" justifyContent="start" spacing={1}>
          <Stack direction="row" alignItems="center" spacing={2}>
            {staff.status === 'MEDECIN' && <DoctorIcon isFemale={staff.userInfo.gender === 'F'} />}
            {staff.status === 'PDS' && <PdsIcon isFemale={staff.userInfo.gender === 'F'} />}
            <Typography>{staff.userInfo.name} <b>{staff.userInfo.surname}</b></Typography>
          </Stack>
          <Typography fontWeight="500" color="#4F46E5" style={{ fontWeight: 'bold' }}>
            {staff.status}
          </Typography>
        </Stack>
        <Stack direction="column" justifyContent="start" spacing={1}>
          <Typography fontWeight="400" sx={{ textDecoration: 'underline', wordBreak: 'break-all' }}>
            {staff.email}
          </Typography>
          <Typography>{staff.contactInfo?.phone ?? '+33 - - - - -'}</Typography>
        </Stack>
      </Stack>
    </Card>
  )
}
